import config from '../../../api/config'

export default {
  async index({commit}) {
    commit('setFetching', true)
    const resp = await config.index()
    commit('setConfigData', resp.data.data)
    commit('setFetching', false)
  },
  setChrome({commit}){
    commit('setChrome')
  },
  removeChrome({commit}){
    commit('removeChrome')
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/config/actions.js